<template>
	<tr
		class="signature-status text-start card !rounded-none [&.error]:!border-red-500 bg-secondary m-0 [&:last-child]:!mb-0"
		:class="[
			this.sigStatus?.confirmationStatus,
			{
				error: this.sigStatus?.err,
			},
		]"
		@click="linkTo"
	>
		<td class="[.error_&]:table-cell [:is(.confirmed,_.finalized,_.processed)_&]:table-cell">
			<i class="bi-x-circle-fill text-error [.error_&]:inline-block hidden"></i>
			<i class="bi-check-circle-fill text-success [:is(.confirmed,_.finalized,_.processed):not(.error)_&]:inline-block hidden"></i>
		</td>
		<td v-if="humanStatus === 'Processed' || humanStatus === 'Processed'" class="text-start">
			<Spinner />
		</td>
		<td class="whitespace-nowrap">
			<SignatureAddress v-if="signature.length > 32" :address="signature"></SignatureAddress>
		</td>
		<td class="progress-container !pr-[3px]">
			<div class="progress !py-4 !rounded-md !border-none">
				<div
					class="progress-bar"
					role="progressbar"
					:style="statusStyl"
					:aria-valuenow="progressValue"
					aria-valuemin="0"
					aria-valuemax="100"
				></div>
			</div>
			<code class="progress-code">{{ error ? error : humanStatus }}</code>
		</td>
	</tr>
</template>

<script>
import SignatureAddress from "@/components/common/SignatureAddress.vue";
import { parseCustomErrorInt } from "@/api/token_swap/errors";
import Spinner from "@/components/common/Spinner.vue";

export default {
	name: "SignatureStatus",
	components: { SignatureAddress, Spinner },
	props: {
		signature: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			sigStatus: {
				// err: true,
				// confirmationStatus: "processed"
			},
			humanStatus: "Sending...",
			interval: null,
			progressValue: 0,
			notiSent: false,
		};
	},
	computed: {
		error: function () {
			if (!this.sigStatus?.err) {
				return "";
			}

			if (Array.isArray(this.sigStatus?.err)) {
				const errCode = this.sigStatus?.err[1]?.Custom;
				return parseCustomErrorInt(errCode)?.msg || "";
			}

			if (!this.sigStatus?.err?.InstructionError) return this.sigStatus?.err;

			const errCode = this.sigStatus?.err?.InstructionError[1]?.Custom;
			return parseCustomErrorInt(errCode)?.msg || "";
		},

		backgroundStyl: function () {
			if (this.sigStatus?.confirmationStatus !== "confirmed") return {};

			return {
				backgroundColor: "rgb(25 135 84 / 25%)",
			};
		},

		statusStyl: function () {
			if (this.sigStatus?.err) {
				return {
					width: `100%`,
					maxWidth: `100%`,
					backgroundColor: "red",
				};
			}

			const styl = {
				width: `100%`,
				maxWidth: `100%`,
			};
			switch (this.humanStatus) {
				case "Processed":
					styl.backgroundColor = "rgb(25 135 84 / 50%)";
					break;
				case "Confirmed":
				case "Finalized":
					styl.maxWidth = "100%";
					styl.backgroundColor = "rgb(25 135 84 / 100%)";
					break;
				default:
					// styl.maxWidth = "0%"
					// styl.backgroundColor = "rgb(13 110 253 / 50%)"

					styl.maxWidth = `${this.progressValue}%`;
					styl.backgroundColor = "rgb(255 255 255 / 15%)";
					break;
			}
			return styl;
		},
	},
	methods: {
		getProgressValue: function () {
			if (
				!this.sigStatus?.confirmations ||
				this.sigStatus?.confirmations === 0
			) {
				return ((new Date() - this.sigStatus.createdAt) / 60_000) * 100;
			}

			return ((this.sigStatus?.confirmations || 30) / 30) * 100;
		},

		getHumanStatus: function () {
			if (this.sigStatus?.confirmationStatus === "timeout") return "Timeout";

			if (this.sigStatus?.err) return "Error";

			// Check for finalized status first to prioritize it over timeout
			if (this.sigStatus?.confirmationStatus === "finalized") return "Finalized";

			switch (this.sigStatus?.confirmationStatus) {
				case "processed":
					return "Processed";
				case "confirmed":
					return "Confirmed";
				default:
					return "Sending...";
			}
		},

		linkTo: function () {
			window.open(this.link(), "_blank");
		},
		link: function () {
			return `${this.$store.state.settings.explorer}/tx/${this.signature}?${this.$store.getters["settings/clusterQuery"]}`;
		},
	},
	mounted() {
		this.progressInterval = setInterval(() => {
			if (this.done) {
				clearInterval(this.progressInterval);
				return;
			}

			const s = this.$store.state.signatures.activeSignatures[this.signature];
			if (!s) return;

			this.sigStatus = s;
			this.humanStatus = this.getHumanStatus();
			this.progressValue = this.getProgressValue();
			if (this.sigStatus.confirmationStatus === "confirmed" ||
			    this.sigStatus.confirmationStatus === "finalized" ||
			    this.sigStatus.confirmations > 0 ||
			    this.sigStatus.err)
				this.done = true;
		}, 300);
	},
	beforeDestroy() {
		if (this.progressInterval) clearInterval(this.progressInterval);
	},
};
</script>

<style scoped>
tr {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: row;
	flex-wrap: nowrap;
	transition: background-color 0.3s linear;
	border: none !important;
	border-radius: 0 !important;
}

td {
	padding-top: 3px;
	padding-bottom: 3px;
}

tr:not(.error):hover {
	cursor: pointer;
	background: rgba(255, 255, 255, 0.2);
}

.progress {
	width: 100%;
	height: 2vh;
	border-radius: 0;
	border: 1px solid white;
	background: transparent;
	transition: background-color 0.3s linear;
}

.progress-bar {
	transition: all 0.3s linear;
}

.progress-container {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 60%;
}

.progress-container code {
	position: absolute;
	width: 100%;
	text-align: center;
	background: transparent;
	font-size: 0.8rem;
}
.confirmed,
.finalized {
	background-color: rgba(var(--green500), 0.2) !important;
}

.error {
	background-color: rgba(var(--red500), 0.2) !important;
}
</style>
